import React from "react";
import ResetForm from "../../forms/auth/ResetForm";

const ResetPasswordView = ({ initialValues, onSubmit = () => {} }) => {
  return <ResetForm onSubmit={onSubmit} initialValues={initialValues} />;
};

export default ResetPasswordView;
